<svg
    width="311"
    height="187"
    viewBox="0 0 311 187"
    xmlns="http://www.w3.org/2000/svg">
    <g
        app-roof
        [type]="type()"></g>

    <g
        [x]="-20"
        [y]="-55"
        [hideLowerBox]="true"
        app-roof-box></g>

    <g
        [x]="-70"
        [y]="15"
        [hideLowerBox]="true"
        app-roof-box></g>

    <g
        [x]="-60"
        [y]="65"
        app-square-vent></g>
</svg>
